import SelectionSummary from './selection_summary';

export default SelectionSummary;
